import { useId } from "react";
import HomeSpotlightCard from "@/components/featureSpotlight/HomeSpotlightCard";
import { useHomeSpotlight } from "@/components/featureSpotlight/useHomeSpotlight";

/**
 * O destaque de lançamento da tela inicial (abaixo dos atalhos do Lucas): a novidade de maior prioridade que o cadastro
 * mandou para a tela inicial. É o mesmo sistema das novidades do menu (público, agenda, prioridade e funil), só desenhado
 * aqui. Sem novidade para a pessoa, não ocupa lugar.
 *
 * @param {{
 *   environment: { visibleNavKeys: string[], resolveAccountPath: (subPath: string) => string, canSeeTarget?: (target: object) => boolean } | null | undefined,
 *   visible?: boolean,
 * }} props `environment` vem do layout; `visible` é falso enquanto a tela inicial está escondida (o Lucas aberto)
 */
export default function HomeLaunchSpotlight({ environment, visible = true }) {
  const titleId = useId();
  const { spotlight, dismiss, tryIt } = useHomeSpotlight({ environment, visible });
  if (!spotlight) return null;

  return (
    <HomeSpotlightCard
      title={spotlight.title}
      body={spotlight.body}
      badge={spotlight.badge}
      ctaLabel={spotlight.ctaLabel}
      artKey={spotlight.artKey}
      mediaUrl={spotlight.mediaUrl}
      mediaType={spotlight.mediaType}
      titleId={titleId}
      onTry={tryIt}
      onDismiss={dismiss}
    />
  );
}
